import * as React from 'react';

import { Modal, Space, Text } from 'farmhub-ui-core';

import { useAppSelector } from 'app';
import LazyLoadingPage from 'components/Commons/LazyLoadingPage';
import { selectAccount } from 'slice';

import { LoadingWrapper, ModalMobileStyles, WrapperContent } from './styles';

const LoadingChangeAccountModal = ({
  isHideLoading,
}: {
  isHideLoading: boolean;
}): JSX.Element => {
  const account = useAppSelector(selectAccount);

  return (
    <>
      {account.isFirstLoading || isHideLoading ? (
        <></>
      ) : (
        <Modal
          centered
          bodyHeight="auto"
          maskClosable={false}
          styles={ModalMobileStyles}
          visible={account.isSelectedAccount}
          onCancel={() => false}
        >
          <WrapperContent>
            <LoadingWrapper>
              <LazyLoadingPage />
            </LoadingWrapper>
            <Text color="dark" size="sm" weight="bold">
              Đang tải dữ liệu
            </Text>
            <Space height={4} />
            <Text size="xxs" styles={{ textAlign: 'center' }}>
              Dữ liệu thực thể đang được khởi tạo. Vui lòng chờ trong giây lát.
            </Text>
          </WrapperContent>
        </Modal>
      )}
    </>
  );
};

export default LoadingChangeAccountModal;
